module.exports = __webpack_public_path__ + "static/media/desenv-TI.3219cada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/desenv-TI.png
// module id = 319
// module chunks = 0